import { IReduxState } from 'types/redux';

export const categoriesVisibilitySelector = (state: IReduxState) => state.categories.categoriesVisibility;

export const zonesCategoriesSelector = (state: IReduxState) => state.categories.zones;

export const categoriesGroupingsSelector = (state: IReduxState) => state.categories.groupings;
